"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChartPie = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var ChartPie = function ChartPie() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M19.971 13.084c.2 0 .363.162.355.362a9.417 9.417 0 11-9.771-9.771c.2-.008.362.155.362.355v8.91c0 .08.065.144.145.144h8.909z"
  }), react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M22.144 11.635c.2 0 .363-.162.356-.362A10.142 10.142 0 0012.727 1.5a.352.352 0 00-.362.356v9.417c0 .2.162.362.362.362h9.417z",
    opacity: "0.72"
  }));
};

exports.ChartPie = ChartPie;